import React from "react";
import {BrowserRouter} from "react-router-dom";
// import Navbar from "./components/Navbar";
import AppRoutes from "./app/routes/AppRoutes";
import ThemeWrapper from "./app/features/theme/components/ThemeWrapper";
import {OverlayScrollbarsComponent} from "overlayscrollbars-react";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ThemeWrapper>
        <main>
          <OverlayScrollbarsComponent
            style={{height: '100%'}}
            options={{
              scrollbars: {
                autoHide: 'scroll',
                autoHideDelay: 300,
                visibility: 'auto',
                dragScroll: true,
                clickScroll: true
              }
            }}
          >
            <AppRoutes/>
          </OverlayScrollbarsComponent>
        </main>
      </ThemeWrapper>
    </BrowserRouter>
  );
};

export default App;